<template>
  <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute left-0 top-0 pointer-events-none" />

  <div class="relative z-10 flex space-x-2 text-3xl font-medium">
    <ModuleIcon class="w-6 h-6 mt-1 mr-2" color="black" /> {{ $t("Add New Component") }}
  </div>
  <div class="relative z-10 -mt-1 text-sm text-common-grey">
    {{ $t("Customize your page by adding components that fits your needs!") }}
  </div>
  <PageBreadCrumb v-if="step !== 'main' && !is_replace_component" :is-page-title-hidden="true" :page-bread-crumb="breads" class="-ml-8" />

  <div class="mt-12 mb-6">
    <div v-if="!form_active" class="flex w-full mb-10 ml-auto rounded-md shadow-sm">
      <div class="relative flex items-stretch flex-grow focus-within:z-10">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <Search class="z-10 w-5 h-5 text-gray-400" aria-hidden="true" />
        </div>
        <TextInput
          :value="search_term"
          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
          name="search_term"
          type="text"
          :validate-on-input="true"
          :label="$t('Search the Components library')"
          :icon="true"
          @update:modelValue="
            (e) => {
              search_term = e
            }
          " />
      </div>
    </div>
  </div>

  <div
    v-if="components_list.find((c) => c.slug == step.split('__')[1])?.new_name && !form_active"
    class="flex border rounded-md border-[#2DA7D7] w-fit p-2 cursor-pointer hover:bg-[#2DA7D710]"
    @click="handleAddNewComponentClick">
    <AddNewComponentIcon class="mr-4" /> {{ $t("Create New") }}
    {{ components_list.find((c) => c.slug == step.split("__")[1])?.new_name }}
  </div>

  <div v-if="step == 'main'">
    <FrequentlyUsedList v-show="false" />

    <CategoriesList
      v-if="filtered_components_lists_groups.length && !form_active"
      :categories="filtered_components_lists_groups"
      @category-select="handleCategorySelect" />

    <div v-if="form_active">
      <CreateAndEditComponentForms
        :page-reference="pageReference"
        :instance-to-edit="instance_to_edit"
        :object-type="object_type_to_filter_with"
        :component-selected="selected_component"
        @submitForm="submitForm"
        @cancel="
          () => {
            instance_to_edit = null
            selected_component = null
            form_active = false
          }
        "
        @newComponentDataChange="($event) => handleNewComponentDataChange($event)" />
    </div>

    <ComponentList
      v-else
      :search-term="search_term"
      :change-instance-hidden="changeInstanceHidden"
      :delete-instance="deleteInstance"
      :edit-instance="editInstance"
      :create-new-instance="createNewInstance"
      :component-list="sub_components_list"
      :page-reference="pageReference"
      :current-template="currentTemplate"
      @open-edit-form="handleOpenEditForm"
      @open-add-new-form="handleOpenAddNewForm" />
  </div>

  <div v-if="step.split('_')[0] == 'category'">
    <CategoryComponentsList
      v-if="step.split('__')[1] !== 'portfolio_overview' && !form_active"
      :current-category="components_lists_groups.find((g) => g.id == step?.split('__')[1]).group_name"
      :components="filtered_category_components_list"
      @component-select="handleComponentSelect" />

    <div v-if="form_active">
      <CreateAndEditComponentForms
        :page-reference="pageReference"
        :instance-to-edit="instance_to_edit"
        :object-type="object_type_to_filter_with"
        :component-selected="selected_component"
        @submitForm="submitForm"
        @cancel="
          () => {
            instance_to_edit = null
            selected_component = null
            form_active = false
          }
        "
        @newComponentDataChange="($event) => handleNewComponentDataChange($event)" />
    </div>

    <ComponentList
      v-else
      :change-instance-hidden="changeInstanceHidden"
      :delete-instance="deleteInstance"
      :edit-instance="editInstance"
      :create-new-instance="createNewInstance"
      :component-list="sub_components_list"
      :page-reference="pageReference"
      :current-template="currentTemplate"
      @open-edit-form="handleOpenEditForm"
      @open-add-new-form="handleOpenAddNewForm" />
  </div>

  <div v-if="step.split('_')[0] == 'component'">
    <div v-if="form_active">
      <CreateAndEditComponentForms
        :page-reference="pageReference"
        :instance-to-edit="instance_to_edit"
        :object-type="object_type_to_filter_with"
        :component-selected="selected_component"
        @submitForm="submitForm"
        @cancel="
          () => {
            instance_to_edit = null
            selected_component = null
            form_active = false
          }
        "
        @newComponentDataChange="($event) => handleNewComponentDataChange($event)" />
    </div>

    <ComponentList
      v-else
      :change-instance-hidden="changeInstanceHidden"
      :delete-instance="deleteInstance"
      :edit-instance="editInstance"
      :create-new-instance="createNewInstance"
      :component-list="sub_components_list"
      :page-reference="pageReference"
      :current-template="currentTemplate"
      @open-edit-form="handleOpenEditForm"
      @open-add-new-form="handleOpenAddNewForm" />
  </div>

  <div class="w-full flex">
    <button v-if="is_replace_component" class="btn cancel-btn w-fit h-8 mt-6" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
    <button v-else-if="step !== 'main'" class="btn mt-6 cancel-btn text-light-brand-blue border-light-brand-blue" @click="handleBackClick">
      <ArrowLeft class="w-5 h-5 mr-2" />
      {{
        step.split("_")[0] == "category"
          ? $t("Add Other Components")
          : step.split("_")[0] == "component"
            ? $t("Add Other") + ` ${$utils.capitalize(current_component_category.group_name)} ` + $t("Component")
            : $t("Back")
      }}
    </button>
    <button v-if="!is_replace_component" class="btn cancel-btn w-fit ml-auto h-8 mt-6" @click="$emit('cancel')">{{ $t("Done") }}</button>
  </div>
</template>

<script>
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import { event as google_event } from "vue-gtag-next"
import ComponentList from "./ComponentList"

import PageBreadCrumb from "@/components/shared/pages/PageBreadCrumb.vue"

import TextInput from "@/components/shared/TextInput.vue"
import { Search, ArrowLeft } from "lucide-vue-next"
import FrequentlyUsedList from "./FrequentlyUsedList"
import CategoriesList from "./CategoriesList"

import CategoryComponentsList from "./CategoryComponentsList"
import { ALL_COMPONENTS } from "@/store/constants/all_components"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

import { MODULES } from "@/store/constants/references"
import dataService from "@/services/data.service"

import { v4 as uuidv4 } from "uuid"

import CreateAndEditComponentForms from "./forms/CreateAndEditComponentForms"
import AddNewComponentIcon from "@/components/shared/icons/AddNewComponentIcon.vue"
import { utils } from "@/store/helpers"

export default {
  components: {
    Search,
    PageBreadCrumb,
    ModuleIcon,
    CreateAndEditComponentForms,
    TextInput,
    ComponentList,
    FrequentlyUsedList,
    CategoriesList,
    CategoryComponentsList,
    ArrowLeft,
    AddNewComponentIcon
  },
  inject: ["setPageLayout", "isModuleActivated"],

  props: {
    currentTemplate: {
      type: Object,
      required: true
    },
    pageReference: {
      type: String,
      default: "dashboard"
    }
  },
  emits: ["cancel"],

  data() {
    return {
      is_replace_component: false,
      new_component_data: null,
      creation_form_filled: false,
      user_forecasts: [],
      forecasted_objects: [],
      expansion_lists: [],
      form_active: false,
      instance_to_edit: null,
      selected_component: null,
      items_changed: false,
      search_term: "",
      journeys: [],
      step: "main",
      action_table_options: [
        { name: this.$t("Plans"), value: "plans" },
        { name: this.$t("Goals"), value: "goals" },
        { name: this.$t("Tasks"), value: "tasks" },
        { name: this.$t("Interactions"), value: "interactions" }
      ],
      standard_metrics_options: [
        { name: this.$t("Plans"), value: "plan", title: this.$t("Plans"), sub_title: this.$t("Total count"), type: "plan", count: 0 },
        { name: this.$t("Goals"), value: "goal", title: this.$t("Goals"), sub_title: this.$t("Total count"), type: "goal", count: 0 },
        { name: this.$t("Tasks"), value: "task", title: this.$t("Tasks"), sub_title: this.$t("Total count"), type: "task", count: 0 },
        {
          name: this.$t("Interactions"),
          value: "interaction",
          title: this.$t("Interactions"),
          sub_title: this.$t("Total count"),
          type: "interaction",
          count: 0
        },
        {
          name: this.$t("Meetings"),
          value: "meeting",
          title: this.$t("Meetings"),
          sub_title: this.$t("Total count"),
          type: "meeting",
          count: 0
        },
        { name: this.$t("Emails"), value: "email", title: this.$t("Emails"), sub_title: this.$t("Total count"), type: "email", count: 0 },
        { name: this.$t("Calls"), value: "call", title: this.$t("Calls"), sub_title: this.$t("Total count"), type: "call", count: 0 }
      ],

      lead_table_options: [
        { name: this.$t("Growth Matrix"), value: "growth_matrix" },
        { name: this.$t("Suggested Lists"), value: "suggested" }
      ],
      milestone_component_type_options: [
        { value: "full", label: this.$t("Full") },
        { value: "short", label: this.$t("Short") }
      ]
    }
  },

  computed: {
    forecast_metrics_list() {
      return [
        { name: this.$t("ARR"), value: "arr" },
        { name: this.$t("MRR"), value: "mrr" },
        { name: this.$t("GRR"), value: "grr" },
        { name: this.$t("NRR"), value: "nrr" },
        { name: this.$t("Delta%"), value: "delta_" },
        { name: this.$t("Flag"), value: "flag" },
        { name: this.$t("Delta"), value: "delta" },
        { name: this.$t("Churn Amount"), value: "churn_amount" },
        { name: this.$t("Bookings"), value: "bookings" },
        { name: this.$t("Gap to GRR"), value: "gap_to_grr" },
        { name: this.$t("Gap to NRR"), value: "gap_to_nrr" },
        { name: this.$t("Gap to Bookings"), value: "gap_to_bookings" },
        { name: this.$t("Forecast Status"), value: "forecast_status" },
        { name: this.$t("Forecast Summary"), value: "forecast_summary" }
      ]
    },

    sub_components_list() {
      const list_calc = []
      this.filtered_components_list.forEach((c) => {
        c.sub_components?.forEach((s) => {
          if (
            utils.isEmpty(this.search_term) ||
            (utils.isNotEmpty(this.search_term) &&
              (s.name.toLowerCase().includes(this.search_term.toLowerCase()) ||
                c.group_name.toLowerCase().includes(this.search_term.toLowerCase()) ||
                s.instances.filter((ins) => ins.props?.component_props?.label?.toLowerCase().includes(this.search_term.toLowerCase()))
                  .length))
          ) {
            list_calc.push({
              ...s,
              group_name: c.group_name,
              icon: c.icon,
              icon_color_1: c.icon_color_1,
              icon_color_2: c.icon_color_2
            })
          }
        })
      })

      return list_calc
    },
    breads() {
      const breads_calc = [
        {
          id: 1,
          label: this.$t("Main"),
          is_component: true,
          component: "House",

          onClick: () => {
            this.step = "main"
            this.search_term = ""
          }
        }
      ]

      if (this.step.split("__")[0] == "category") {
        breads_calc.push({
          id: 2,
          label: this.components_lists_groups.find((c) => c.id == this.step.split("__")[1]).group_name
        })
      }

      if (this.step.split("__")[0] == "component") {
        breads_calc.push({
          id: 2,
          label: this.current_component_category.group_name,

          onClick: () => {
            this.step = `category__${this.current_component_category.id}`
            this.search_term = ""
          }
        })

        breads_calc.push({
          id: 3,
          label: this.components_list.find((c) => c.slug == this.step.split("__")[1]).name
        })
      }
      return breads_calc
    },
    current_component_category() {
      const current_component = this.step.split("__")[1]

      const group_calc = this.components_lists_groups.find((g) => g.components.includes(current_component))

      return group_calc
    },
    table_sources() {
      const tables_in_layout = this.currentTemplate.layout?.filter((item) => item.props.component_type.includes("table"))
      const tables_list_calc = tables_in_layout.map((table_item) => {
        // { name: "Company Table 1", id: 1, object_type: "company", visible: true },
        return {
          props: table_item.props,
          name: table_item.props.component_props.label,
          component_reference: table_item.props.component_reference
        }
      })
      return tables_list_calc
    },
    /**'This Record' is to tie component to current page record (only visible if inside company page)
     * 'Specific Record' is to tie component to selected desired record
     * */
    connect_to_options() {
      if ((this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile") && !this.is_inside_object_page) {
        return [
          { name: this.$t("This Record"), value: "this_record" },
          { name: this.$t("Specific Record"), value: "another_record" }
        ]
      } else {
        return [{ name: this.$t("Specific Record"), value: "another_record" }]
      }
    },

    action_options() {
      return [
        { name: this.$t("Plans"), value: "plans" },
        { name: this.$t("Goals"), value: "goals" },
        { name: this.$t("Tasks"), value: "tasks" },
        { name: this.$t("Interactions"), value: "interactions" }
      ]
    },

    sources() {
      if ((this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile") && !this.is_inside_object_page) {
        return [
          {
            name: this.$t("All Records"),
            id: "all_records",
            component_reference: "all_records"
          },
          {
            name: this.$t("This Record"),
            id: "this_record",
            component_reference: "this_record"
          },
          {
            name: this.$t("Specific Record"),
            id: "another_record",
            component_reference: "another_record"
          }
        ]
      } else {
        return [
          {
            name: this.$t("All Records"),
            id: "all_records",
            component_reference: "all_records"
          },
          {
            name: this.$t("Specific Record"),
            id: "another_record",
            component_reference: "another_record"
          }
        ]
      }
    },

    graph_sources() {
      if ((this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile") && !this.is_inside_object_page) {
        return [
          { name: this.$t("All Records"), id: "all_records", component_reference: "all_records" },
          { name: this.$t("This Record"), id: "this_record", component_reference: "this_record" },
          {
            name: this.$t("Specific Record"),
            id: "another_record",
            component_reference: "another_record"
          }
        ]
      } else {
        return [
          { name: this.$t("All Records"), id: "all_records", component_reference: "all_records" },
          {
            name: this.$t("Specific Record"),
            id: "another_record",
            component_reference: "another_record"
          }
        ]
      }
    },

    filtered_components_list() {
      const filtered_components_list_calc = []
      this.components_lists_groups.forEach((group) => {
        const group_components = group.components

        const components_full = group_components.map((component_slug) => this.components_list.find((c) => c.slug == component_slug))

        const group_components_filtered = components_full.filter(
          (comp) =>
            comp.name.toLowerCase().includes(this.search_term.toLowerCase()) ||
            group.group_name.toLowerCase().includes(this.search_term.toLowerCase()) ||
            comp?.sub_components?.filter(
              (s) =>
                s.name.toLowerCase().includes(this.search_term.toLowerCase()) ||
                s.instances.filter((ins) => ins.props?.component_props?.label?.toLowerCase().includes(this.search_term.toLowerCase()))
                  .length
            ).length
        )
        group_components_filtered.forEach((g_c) => {
          if (this.step.split("__")[0] == "category") {
            if (group.id == this.step.split("__")[1]) {
              filtered_components_list_calc.push({
                ...g_c,
                group_name: group.group_name,
                icon: group.icon,
                icon_color_1: group.background_color_1,
                icon_color_2: group.background_color_2
              })
            }
          } else if (this.step.split("__")[0] == "component") {
            if (g_c.slug == this.step.split("__")[1]) {
              filtered_components_list_calc.push({
                ...g_c,
                group_name: group.group_name,
                icon: group.icon,
                icon_color_1: group.background_color_1,
                icon_color_2: group.background_color_2
              })
            }
          } else if (this.step == "main") {
            filtered_components_list_calc.push({
              ...g_c,
              group_name: group.group_name,
              icon: group.icon,
              icon_color_1: group.background_color_1,
              icon_color_2: group.background_color_2
            })
          }
        })
      })

      return filtered_components_list_calc
    },

    filtered_category_components_list() {
      const category_selected = this.components_lists_groups.find((g) => g.id == this.step.split("__")[1])

      const components_full = category_selected?.components.map((component_slug) => {
        return {
          ...this.components_list.find((c) => c.slug == component_slug),
          icon: category_selected.icon,
          icon_color_1: category_selected.background_color_1,
          icon_color_2: category_selected.background_color_2
        }
      })

      return components_full?.filter((c) => c.name.toLowerCase().includes(this.search_term))
    },

    components_list() {
      const in_workspace = this.$route.name == "WorkspaceItem"
      const current_workspace = this.$store.state.ui.currentWorkspace

      let dynamic_source_object_type = null
      let dynamic_source_type = null
      let dynamic_source_selection_id = null
      const dynamic_data_source = this.currentTemplate.layout?.find((item) => item.id == "dynamic_source_selection")
      if (dynamic_data_source) {
        const dynamic_data_source_array = dynamic_data_source.data_source_string.split(">")
        dynamic_source_object_type = dynamic_data_source_array[0]
        dynamic_source_type = dynamic_data_source_array[1]
        dynamic_source_selection_id = dynamic_data_source_array[2]
      }

      //ACTIVITY TABLES
      const activity_tables = {
        group: "lifecycle_and_workflows",
        slug: "action_table",
        name: this.$t("Activities"),
        description: this.$t("Add an overview of important activities like goals, task & customer interactions."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.ACTIONS_TABLE && !item.hidden
        ).length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.ACTIONS_TABLE,
            id: ALL_COMPONENTS.ACTIONS_TABLE,

            name: this.$t("Activity Table"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your table"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "multi_select",
                label: this.$t("Visible tabs"),
                options: this.action_table_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "view_by"
              },
              {
                type: "actions_filter",
                column_full_span: true,
                label: this.$t("Filter"),
                required: false,
                component_prop_name: "initialFilter",
                dynamic_data_source: {
                  object_type: dynamic_source_object_type,
                  type: dynamic_source_type,
                  id: dynamic_source_selection_id
                },
                workspace_record: in_workspace ? current_workspace.record : ""
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.ACTIONS_TABLE)
          }
        ]
      }

      //Activities Standard Metrics
      const standard_metrics = {
        group: "lifecycle_and_workflows",
        slug: "standard_metrics",
        name: this.$t("Activities Standard Metrics"),
        description: this.$t("Add Activities Standard Metrics."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.STANDARD_METRICS && !item.hidden
        ).length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.STANDARD_METRICS,
            id: ALL_COMPONENTS.STANDARD_METRICS,

            name: this.$t("Activities Standard Metrics"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your component"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "multi_select",
                label: this.$t("Visible tabs"),
                options: this.standard_metrics_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "view_by"
              },
              {
                type: "select",
                label: this.$t("Data Source"),
                disabled: in_workspace || dynamic_data_source,
                options: this.sources.concat(
                  this.$store.state.data?.groups.map((g) => {
                    return { ...g, value: g.id, component_reference: g.id }
                  })
                ),
                create_group_action: true,
                value_attr: "component_reference",
                label_attr: "name",
                required: true,
                component_prop_name: "dataSource",
                default_value:
                  in_workspace || dynamic_source_type == "specific_record"
                    ? "another_record"
                    : dynamic_source_type == "group"
                      ? dynamic_source_selection_id
                      : null
              },
              {
                type: "company_select",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "dataSource",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.STANDARD_METRICS)
          }
        ]
      }

      //Send Email
      const send_email = {
        group: "lifecycle_and_workflows",
        slug: "send_email",
        name: this.$t("Send Email"),
        description: this.$t("Send emails."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.SEND_EMAIL && !item.hidden)
          .length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.SEND_EMAIL,
            id: ALL_COMPONENTS.SEND_EMAIL,

            name: this.$t("Send Email"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your component"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.SEND_EMAIL)
          }
        ]
      }

      //MILESTONE COMPONENT
      const milestone_components = {
        group: "lifecycle_and_workflows",
        slug: "milestone",
        name: this.$t("Milestone"),
        description: this.$t("Add an overview of important goals and task."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.MILESTONE && !item.hidden)
          .length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.MILESTONE,
            id: ALL_COMPONENTS.MILESTONE,

            name: this.$t("Milestone"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your flow"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "select",
                label: this.$t("Component Type"),
                options: this.milestone_component_type_options,
                value_attr: "value",
                label_attr: "label",
                required: true,
                default_value: "full",
                component_prop_name: "componentType"
              },
              {
                type: "date_input",
                label: this.$t("Start date"),
                required: false,
                component_prop_name: "start_date"
              },
              {
                type: "date_input",
                label: this.$t("Due date"),
                required: false,
                component_prop_name: "due_date"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.MILESTONE)
          }
        ]
      }

      //SMART LEADS TABLE
      const lead_tables = {
        group: "expansion_and_growth",
        slug: "lead_table",
        name: this.$t("Prospecting Table"),
        description: this.$t("Add a flexible Prospecting search."),
        icon: "LeadComponentIcon",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.LEADS_TABLE && !item.hidden)
          .length,
        sub_components: [
          {
            component_type: ALL_COMPONENTS.LEADS_TABLE,
            id: ALL_COMPONENTS.LEADS_TABLE,
            name: this.$t("Smart Leads Table"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your table"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "multi_select",
                label: this.$t("View by"),
                options: this.lead_table_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "view_by"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.LEADS_TABLE)
          }
        ]
      }

      //FORECASTING TABLES
      const forecasting_tables = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.FORECASTING_TABLE && !item.hidden
        ).length,
        group: "revenue",
        slug: "forecast_table",
        name: this.$t("Forecasting Overview"),
        description: this.$t("Show your forecasts including status of every record."),
        icon: "TableComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.FORECASTING_TABLE,
            id: ALL_COMPONENTS.FORECASTING_TABLE,
            name: this.$t("Forecast Table"),
            fields: this.isModuleActivated(MODULES.MULTIPLE_FORECASTING_OBJECTS)
              ? [
                  {
                    type: "text_input",
                    label: this.$t("Name your table"),
                    required: true,
                    component_prop_name: "label"
                  },
                  {
                    type: "select",
                    label: this.$t("Object type"),
                    disabled: dynamic_data_source,
                    options: this.forecasted_objects,
                    required: true,
                    value_attr: "type",
                    label_attr: "label",
                    component_prop_name: "objectType",
                    default_value: dynamic_source_object_type
                  },
                  {
                    type: "multi_select_search",
                    disabled: dynamic_source_type == "group",
                    default_value: dynamic_source_selection_id,
                    label: this.$t("Filter by group (optional)"),
                    options: this.$store.state.data?.groups,
                    filter_based_on: "objectType",
                    filter_field: "type",
                    value_attr: "id",
                    label_attr: "name",
                    required: false,
                    component_prop_name: "view_by"
                  },
                  {
                    type: "select",
                    label: this.$t("Selected Forecast"),
                    options: this.user_forecasts,
                    filter_based_on: "objectType",
                    filter_field: "type",
                    value_attr: "id",
                    label_attr: "name",
                    required: true,
                    component_prop_name: "forecast_name"
                  }
                ]
              : [
                  {
                    type: "text_input",
                    label: this.$t("Name your table"),
                    required: true,
                    component_prop_name: "label"
                  },
                  {
                    type: "select",
                    label: this.$t("Object type"),
                    options: this.forecasted_objects,
                    required: true,
                    value_attr: "type",
                    label_attr: "label",
                    component_prop_name: "objectType"
                  },
                  {
                    type: "multi_select_search",
                    label: this.$t("Filter by group (optional)"),
                    options: this.$store.state.data?.groups,
                    filter_based_on: "objectType",
                    filter_field: "type",
                    value_attr: "id",
                    label_attr: "name",
                    required: false,
                    component_prop_name: "view_by"
                  },
                  {
                    type: "select",
                    label: this.$t("Selected Forecast"),
                    options: this.user_forecasts,
                    filter_based_on: "objectType",
                    filter_field: "type",
                    value_attr: "id",
                    label_attr: "name",
                    required: true,
                    component_prop_name: "forecast_name"
                  }
                ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.FORECASTING_TABLE)
          }
        ]
      }

      //Expansion TABLES
      const expansion_tables = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.EXPANSION_LIST_TABLE && !item.hidden
        ).length,
        group: "expansion_and_growth",
        slug: "expansion_table",
        name: this.$t("Saved Lists"),
        description: this.$t("Show Saved lists."),
        icon: "ExpansionComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.EXPANSION_LIST_TABLE,
            id: ALL_COMPONENTS.EXPANSION_LIST_TABLE,
            name: this.$t("Saved Lists"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your table"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "multi_select",
                label: this.$t("View by"),
                options: this.expansion_lists,
                value_attr: "id",
                label_attr: "name",
                required: true,
                component_prop_name: "view_by"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.EXPANSION_LIST_TABLE)
          }
        ]
      }

      //RECORD TABLES
      let record_table_sub_components = []
      this.$store.state.object_types.forEach((object_type) => {
        record_table_sub_components.push({
          component_type: ALL_COMPONENTS.OBJECT_TABLE,
          id: `${object_type.type}_${ALL_COMPONENTS.OBJECT_TABLE}`,
          name: `${this.$utils.makePlural(object_type.label)} ` + this.$t("Table"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your table"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Data Source"),
              disabled: in_workspace || dynamic_data_source,
              options: this.sources,
              create_group_action: false,
              value_attr: "component_reference",
              label_attr: "name",
              required: true,
              component_prop_name: "dataSource",
              default_value: this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile" ? "this_record" : "all_records"
            },
            {
              type: "multi_select_search",
              label: this.$t("Filter by group (optional)"),
              disabled: dynamic_source_type == "group",
              default_value: dynamic_source_type == "group" ? dynamic_source_selection_id : false,
              options: this.$store.state.data?.groups.filter((group) => group.type == object_type.type),
              value_attr: "id",
              label_attr: "name",
              required: false,
              component_prop_name: "view_by"
            },
            {
              type: "company_select",
              disabled: in_workspace || dynamic_source_type == "specific_record",
              type_filter: null,
              label: this.$t("Selected Record"),
              required: true,
              component_prop_name: "linkedRecord",
              linked_field: "dataSource",
              linked_field_value_to_show: "another_record",
              default_value: in_workspace
                ? current_workspace.record
                : dynamic_source_type == "specific_record"
                  ? dynamic_source_selection_id
                  : null
            }
          ],
          settings: { object_type_confined: object_type.type },
          instances: this.currentTemplate.layout?.filter(
            (item) => item.props.component_type == ALL_COMPONENTS.OBJECT_TABLE && item.props.component_props.objectType == object_type.type
          )
        })
      })

      const record_tables = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.OBJECT_TABLE && !item.hidden)
          .length,
        group: "portfolio_overview",
        icon: "RecordsTableComponentIcon",
        slug: "record_table",
        name: this.$t("Records Table"),
        description: this.$t("Show Portfolio data in table format."),
        sub_components: this.object_type_to_filter_with
          ? record_table_sub_components.filter((r) => r.settings.object_type_confined == this.object_type_to_filter_with)
          : record_table_sub_components
      }

      //ROLLUP METRICS
      let rollup_sub_components = []
      this.$store.state.metrics
        .filter((m) => m.aggregation_method)
        .forEach((rollup_metric) => {
          const rollup_data_sources_options = this.sources
            .concat(
              this.table_sources.filter(
                (t) =>
                  !t.props.hidden &&
                  (rollup_metric.object_type == t.props.component_props.objectType ||
                    t.props.component_type == "expansion_table" ||
                    t.props.component_type == "lead_table" ||
                    (t.props.component_type == "forecast_table" && t.props.component_props.objectType == rollup_metric.object_type))
              )
            )
            .concat(
              this.$store.state.data?.groups
                .filter((group) => group.type == rollup_metric.object_type)
                .map((g) => {
                  return { ...g, value: g.id, component_reference: g.id }
                })
            )

          rollup_sub_components.push({
            component_type: ALL_COMPONENTS.ROLLUP_METRIC,
            id: `${rollup_metric.id}_${ALL_COMPONENTS.ROLLUP_METRIC}`,
            settings: {
              object_type_confined: rollup_metric.object_type,
              parent_field_value: rollup_metric.id,
              parent_field_prop_name: "rollup",
              title_extension: [rollup_metric.object_type, rollup_metric.aggregation_method]
            },
            name: rollup_metric.name,
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your rollup"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "select",
                label: this.$t("Data Source"),
                disabled: in_workspace || dynamic_data_source,
                options: rollup_data_sources_options,
                create_group_action: true,
                value_attr: "component_reference",
                label_attr: "name",
                required: true,
                component_prop_name: "dataSource",
                default_value:
                  in_workspace || dynamic_source_type == "specific_record"
                    ? "another_record"
                    : dynamic_source_type == "group"
                      ? dynamic_source_selection_id
                      : null
              },
              {
                type: "company_select",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                type_filter: rollup_metric.object_type,
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "dataSource",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              },
              {
                type: "boolean",
                disabled: in_workspace,
                label: this.$t("Show with description"),
                required: false,
                component_prop_name: "showDescription",
                default_value: false
              }
            ],
            instances: this.currentTemplate.layout?.filter(
              (item) =>
                item.props.component_type == ALL_COMPONENTS.ROLLUP_METRIC && item.props.component_props["rollup"] == rollup_metric.id
            )
          })
        })

      const rollups = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.ROLLUP_METRIC && !item.hidden
        ).length,
        group: "insights",
        icon: "RollupComponentIcon",
        slug: "rollup",
        name: this.$t("Portfolio & Group KPIs"),
        new_name: "Rollup",
        description: this.$t("Add aggregated metrics & KPIs on portfolio or group level."),
        sub_components: this.object_type_to_filter_with
          ? rollup_sub_components.filter((r) => r.settings.object_type_confined == this.object_type_to_filter_with)
          : rollup_sub_components
      }

      //SCORES
      let score_sub_components = []

      this.$store.state.metrics
        .filter((m) => m.aggregation_method && m.metric_class == "score_metric")
        .forEach((score) => {
          const score_data_sources_options = this.sources
            .filter((s) =>
              this.$route.name == "ObjectProfile" || this.$route.name == "CompanyProfile"
                ? score.object_type == this.$store.state.ui.currentCompany?.type
                  ? s.id !== "this_record"
                  : true
                : true
            )
            .concat(
              this.table_sources.filter(
                (t) =>
                  !t.props.hidden &&
                  (score.object_type == t.props.component_props.objectType ||
                    t.props.component_type == "expansion_table" ||
                    t.props.component_type == "lead_table" ||
                    (t.props.component_type == "forecast_table" && t.props.component_props.object_type == score.object_type))
              )
            )
            .concat(
              this.$store.state.data?.groups
                .filter((group) => group.type == score.object_type)
                .map((g) => {
                  return { ...g, value: g.id, component_reference: g.id }
                })
            )
          score_sub_components.push({
            component_type: ALL_COMPONENTS.SCORE,
            id: `${score.id}_${ALL_COMPONENTS.SCORE}`,
            settings: {
              object_type_confined: score.object_type,
              parent_field_value: score.id,
              parent_field_prop_name: "score",
              title_extension: [score.object_type, score.aggregation_method]
            },
            name: score.name,
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your score"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "select",
                label: this.$t("Data Source"),
                options: score_data_sources_options,
                value_attr: "component_reference",
                label_attr: "name",
                required: true,
                component_prop_name: "dataSource",
                default_value:
                  in_workspace || dynamic_source_type == "specific_record"
                    ? "another_record"
                    : dynamic_source_type == "group"
                      ? dynamic_source_selection_id
                      : "all_records",
                disabled: in_workspace || dynamic_source_type
              },
              {
                type: "company_select",
                type_filter: score.object_type,
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "dataSource",
                linked_field_value_to_show: "another_record",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter(
              (item) => item.props.component_type == ALL_COMPONENTS.SCORE && item.props.component_props["score"] == score.id
            )
          })
        })

      const scores = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.SCORE && !item.hidden)
          .length,
        group: "insights",
        icon: "ScoresComponentIcon",
        slug: "score",
        name: this.$t("Scores"),
        new_name: "Score",
        description: this.$t("Add Scores like Health score."),
        sub_components: this.object_type_to_filter_with
          ? score_sub_components.filter((r) => r.settings.object_type_confined == this.object_type_to_filter_with)
          : score_sub_components
      }

      //FORECAST METRICS
      let forecast_metrics_sub_components = []
      const forecast_data_sources_options = this.table_sources.filter(
        (t) => !t.props.hidden && t.props.component_type == ALL_COMPONENTS.FORECASTING_TABLE
      )

      this.forecast_metrics_list.forEach((forecast_metric) => {
        forecast_metrics_sub_components.push({
          component_type: ALL_COMPONENTS.FORECASTING_METRIC,
          id: `${forecast_metric.value}`,
          settings: {
            parent_field_value: forecast_metric.value,
            parent_field_prop_name: "metricName"
          },
          name: forecast_metric.name,
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your metric"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Data Source"),
              options: forecast_data_sources_options,
              value_attr: "component_reference",
              label_attr: "name",
              required: true,
              component_prop_name: "dataSource"
            }
          ],
          instances: this.currentTemplate.layout?.filter(
            (item) =>
              item.props.component_type == ALL_COMPONENTS.FORECASTING_METRIC &&
              item.props.component_props["metricName"] == forecast_metric.value
          )
        })
      })

      const forecast_metrics = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.FORECASTING_METRIC && !item.hidden
        ).length,
        group: "revenue",
        icon: "ForecastingMetricIcon",
        slug: ALL_COMPONENTS.FORECASTING_METRIC,
        name: this.$t("Revenue KPIs"),
        description: this.$t("Add key forecasting & revenue metrics like GRR & NRR."),
        sub_components: forecast_metrics_sub_components
      }

      const calendar_view_options = [
        { value: "month_view", label: this.$t("Month View") },
        { value: "week_view", label: this.$t("Week View") }
      ]
      //CALENDAR
      let calendar_sub_components = [
        {
          component_type: ALL_COMPONENTS.CALENDAR,
          id: ALL_COMPONENTS.CALENDAR,
          name: this.$t("Calendar"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your calendar"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "multi_select",
              label: this.$t("View by"),
              options: this.action_options,
              value_attr: "value",
              label_attr: "name",
              required: true,
              component_prop_name: "view_by"
            },
            {
              type: "select",
              label: this.$t("View Option"),
              options: calendar_view_options,
              value_attr: "value",
              label_attr: "label",
              required: true,
              component_prop_name: "viewOption",
              default: "month_view"
            },
            {
              type: "actions_filter",
              column_full_span: true,
              label: this.$t("Filter"),
              required: false,
              component_prop_name: "initialFilter",
              dynamic_data_source: {
                object_type: dynamic_source_object_type,
                type: dynamic_source_type,
                id: dynamic_source_selection_id
              },
              workspace_record: in_workspace ? current_workspace.record : ""
            }
          ],
          instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.CALENDAR)
        }
      ]

      const calendar_list = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.CALENDAR && !item.hidden)
          .length,
        group: "lifecycle_and_workflows",
        icon: "CalendarComponentIcon",
        slug: ALL_COMPONENTS.CALENDAR,
        name: this.$t("Calendar View"),
        description: this.$t("Show your key activities in a Calendar view."),
        sub_components: calendar_sub_components
      }

      //Checklist
      let checklist_sub_components = [
        {
          component_type: ALL_COMPONENTS.CHECKLIST,
          id: ALL_COMPONENTS.CHECKLIST,
          name: this.$t("Checklists"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your checklist"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Connect to"),
              options: this.connect_to_options,
              value_attr: "value",
              label_attr: "name",
              required: true,
              component_prop_name: "connectTo",
              disabled: in_workspace,
              default_value:
                (this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile") && !this.is_inside_object_page
                  ? "this_record"
                  : "another_record"
            },
            {
              type: "company_select",
              label: this.$t("Select Record"),
              required: true,
              component_prop_name: "linkedRecord",
              linked_field: "connectTo",
              disabled: in_workspace || dynamic_source_type == "specific_record",
              linked_field_value_to_show: "another_record",
              default_value: in_workspace
                ? current_workspace.record
                : dynamic_source_type == "specific_record"
                  ? dynamic_source_selection_id
                  : null
            }
          ],
          instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.CHECKLIST)
        }
      ]

      const checklist_list = {
        group: "customer360",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.CHECKLIST && !item.hidden)
          .length,
        icon: "ChecklistsComponentIcon",
        slug: ALL_COMPONENTS.CHECKLIST,
        name: this.$t("Checklists"),
        description: this.$t("Add a Checklist."),
        sub_components: checklist_sub_components
      }

      //Company Map
      let compnay_map_sub_components = [
        {
          component_type: ALL_COMPONENTS.COMPANY_MAP,
          id: ALL_COMPONENTS.COMPANY_MAP,
          name: this.$t("Company Map & Org. Chart"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your checklist"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Connect to"),
              options: this.connect_to_options,
              value_attr: "value",
              label_attr: "name",
              required: true,
              component_prop_name: "connectTo",
              disabled: in_workspace,
              default_value:
                (this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile") && !this.is_inside_object_page
                  ? "this_record"
                  : "another_record"
            },
            {
              type: "company_select",
              label: this.$t("Select Record"),
              required: true,
              component_prop_name: "linkedRecord",
              linked_field: "connectTo",
              disabled: in_workspace || dynamic_source_type == "specific_record",
              linked_field_value_to_show: "another_record",
              default_value: in_workspace
                ? current_workspace.record
                : dynamic_source_type == "specific_record"
                  ? dynamic_source_selection_id
                  : null
            }
          ],
          instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.COMPANY_MAP)
        }
      ]

      const company_map_list = {
        group: "customer360",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.COMPANY_MAP && !item.hidden)
          .length,
        icon: "CompanyMapComponentIcon",
        slug: ALL_COMPONENTS.COMPANY_MAP,
        name: this.$t("Company Map & Org. Chart"),
        description: this.$t("Add a company & stakeholder map."),
        sub_components: compnay_map_sub_components
      }

      //Overview
      let overview_sub_components = [
        {
          component_type: ALL_COMPONENTS.OVERVIEW,
          id: ALL_COMPONENTS.OVERVIEW,
          name: this.$t("Customer Info & KPIs"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your checklist"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Connect to"),
              options: this.connect_to_options,
              value_attr: "value",
              label_attr: "name",
              required: true,
              component_prop_name: "connectTo",
              disabled: in_workspace,
              default_value:
                (this.$route?.name === "CompanyProfile" || this.$route?.name === "ObjectProfile") && !this.is_inside_object_page
                  ? "this_record"
                  : "another_record"
            },
            {
              type: "company_select",
              label: this.$t("Select Record"),
              required: true,
              component_prop_name: "linkedRecord",
              linked_field: "connectTo",
              disabled: in_workspace || dynamic_source_type == "specific_record",
              linked_field_value_to_show: "another_record",
              default_value: in_workspace
                ? current_workspace.record
                : dynamic_source_type == "specific_record"
                  ? dynamic_source_selection_id
                  : null
            }
          ],
          instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.OVERVIEW)
        }
      ]
      //

      const overview_list = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.OVERVIEW && !item.hidden)
          .length,
        group: "customer360",
        icon: "CompanyOverviewComponentIcon",
        slug: ALL_COMPONENTS.OVERVIEW,
        name: this.$t("Customer Info & KPIs"),
        description: this.$t("Present key info, metrics & KPIs about one customer."),
        sub_components: overview_sub_components
      }

      //Graphs
      let graphs_sub_components = []
      this.$store.state.data.all_graphs.forEach((graph) => {
        const graph_data_sources_options = this.graph_sources.concat(
          this.$store.state.data?.groups
            .filter((group) => group.type == graph.type)
            .map((g) => {
              return { ...g, value: g.id, component_reference: g.id }
            })
        )

        graphs_sub_components.push({
          component_type: ALL_COMPONENTS.GRAPH,
          id: `${graph.id}_${ALL_COMPONENTS.GRAPH}`,
          settings: {
            object_type_confined: graph.type,
            parent_field_value: graph.id,
            parent_field_prop_name: "graph",
            title_extension: [graph.type]
          },
          name: graph.name,
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your graph"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Data Source"),
              disabled: in_workspace || dynamic_data_source,
              options: graph_data_sources_options,
              value_attr: "component_reference",
              label_attr: "name",
              column_full_span: true,
              required: true,
              component_prop_name: "dataSource",
              default_value:
                in_workspace || dynamic_source_type == "specific_record"
                  ? "another_record"
                  : dynamic_source_type == "group"
                    ? dynamic_source_selection_id
                    : null
            },

            {
              type: "company_select",
              type_filter: graph.type,
              label: this.$t("Select Record"),
              required: true,
              column_full_span: true,
              component_prop_name: "linkedRecord",
              linked_field: "dataSource",
              disabled: in_workspace || dynamic_source_type == "specific_record",
              linked_field_value_to_show: "another_record",
              default_value: in_workspace
                ? current_workspace.record
                : dynamic_source_type == "specific_record"
                  ? dynamic_source_selection_id
                  : null
            },

            {
              type: "color_selector",
              label: this.$t("Background Color"),
              disabled: in_workspace || dynamic_data_source,
              required: true,
              component_prop_name: "backgroundColor",
              default_value: "white"
            },
            {
              type: "color_selector",
              label: this.$t("Text Color"),
              disabled: in_workspace || dynamic_data_source,
              required: true,
              component_prop_name: "textColor",
              default_value: "black"
            }
          ],
          instances: this.currentTemplate.layout?.filter(
            (item) => item.props.component_type == ALL_COMPONENTS.GRAPH && item.props.component_props?.graph == graph.id
          )
        })
      })

      const graphs = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.GRAPH && !item.hidden)
          .length,
        group: "insights",
        icon: "GraphComponentIcon",
        slug: "graph",
        name: this.$t("Graphs"),
        new_name: "Graph",
        description: this.$t("Visualize key data in graphs & charts."),
        sub_components: this.object_type_to_filter_with
          ? graphs_sub_components.filter((r) => r.settings.object_type_confined == this.object_type_to_filter_with)
          : graphs_sub_components
      }

      const journey_component_type_options = [
        { value: "summary", label: this.$t("Summary") },
        { value: "journey", label: this.$t("Journey") },
        { value: "detailed", label: this.$t("Detailed") }
      ]

      //JOURNEYS
      let journey_sub_components = []

      this.journeys.forEach((journey) => {
        journey_sub_components.push({
          component_type: ALL_COMPONENTS.JOURNEY,
          id: `${journey.id}_${ALL_COMPONENTS.JOURNEY}`,
          settings: {
            parent_field_value: journey.id,
            parent_field_prop_name: "journey",
            title_extension: [journey.type]
          },
          name: journey.name,
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your journey"),
              required: true,
              component_prop_name: "label"
            },
            {
              type: "select",
              label: this.$t("Component Type"),
              options: journey_component_type_options,
              value_attr: "value",
              label_attr: "label",
              required: true,
              default_value: "summary",
              component_prop_name: "componentType"
            }
          ],
          instances: this.currentTemplate.layout?.filter(
            (item) => item.props.component_type == ALL_COMPONENTS.JOURNEY && item.props.component_props["journey"] == journey.id
          )
        })
      })

      const journeys = {
        group: "lifecycle_and_workflows",
        icon: "CustomerJourneysIcon",
        slug: "journey",
        name: this.$t("Customer Journeys"),
        description: this.$t("Add customer journeys, in summary or full view."),
        sub_components: journey_sub_components,
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.JOURNEY && !item.hidden)
          .length
      }

      //GROWTH MATRIX
      let grwoth_sub_components = [
        {
          component_type: ALL_COMPONENTS.GROWTH_MATRIX,
          id: ALL_COMPONENTS.GROWTH_MATRIX,
          name: this.$t("Growth Matrix"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your growth matrix"),
              required: true,
              component_prop_name: "label"
            }
          ],
          instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.GROWTH_MATRIX)
        }
      ]

      const growth_matrices = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.GROWTH_MATRIX && !item.hidden
        ).length,
        group: "expansion_and_growth",
        icon: "GrowthMatrixIcon2",
        slug: ALL_COMPONENTS.GROWTH_MATRIX,
        name: this.$t("Portfolio Growth Matrix"),
        description: this.$t("Show key customer groups in a matrix format."),
        sub_components: grwoth_sub_components
      }

      //SUGGESTS LIST
      let suggested_sub_components = [
        {
          component_type: ALL_COMPONENTS.SUGGESTED_LIST,
          id: ALL_COMPONENTS.SUGGESTED_LIST,
          name: this.$t("Suggested List"),
          fields: [
            {
              type: "text_input",
              label: this.$t("Name your suggested list"),
              required: true,
              component_prop_name: "label"
            }
          ],
          instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.SUGGESTED_LIST)
        }
      ]

      const suggested_lists = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.SUGGESTED_LIST && !item.hidden
        ).length,
        group: "expansion_and_growth",
        icon: "SuggestedListIcon",
        slug: ALL_COMPONENTS.SUGGESTED_LIST,
        name: this.$t("Smart Suggestions powered by RevSetter"),
        description: this.$t("Show Suggested leads & customers to focus on."),
        sub_components: suggested_sub_components
      }

      //Prospecting Search
      const find_leads = {
        group: "expansion_and_growth",
        slug: ALL_COMPONENTS.FIND_LEADS,
        name: this.$t("Prospecting Search"),
        description: this.$t("Show saved and recent searches"),
        icon: "SuggestedListIcon",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.FIND_LEADS && !item.hidden)
          .length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.FIND_LEADS,
            id: ALL_COMPONENTS.FIND_LEADS,

            name: this.$t("Prospecting Search"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your Prospecting Search"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.FIND_LEADS)
          }
        ]
      }

      //TEXT
      const text_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.TEXT)

      const texts = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.TEXT && !item.hidden).length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "TextComponentIcon",
        slug: ALL_COMPONENTS.TEXT,
        name: this.$t("Text"),

        sub_components: [
          {
            component_type: ALL_COMPONENTS.TEXT,
            id: ALL_COMPONENTS.TEXT,

            name: this.$t("Text"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: text_instances
          }
        ]
      }

      //New Resources
      const new_resources = {
        group: "resources",
        slug: "new_resources",
        name: this.$t("New resources"),
        description: this.$t("Add new resources."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.NEW_RESOURCES && !item.hidden
        ).length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.NEW_RESOURCES,
            id: ALL_COMPONENTS.NEW_RESOURCES,

            name: this.$t("New Resources"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your component"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.NEW_RESOURCES)
          }
        ]
      }

      //Team chat component
      const team_chat = {
        group: "resources",
        slug: "team_chat",
        name: this.$t("Team Chat"),
        description: this.$t("Add Team Chat."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.TEAM_CHAT && !item.hidden)
          .length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.TEAM_CHAT,
            id: ALL_COMPONENTS.TEAM_CHAT,

            name: this.$t("Team Chat"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your component"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.TEAM_CHAT)
          }
        ]
      }

      //Whatsapp chat component
      const whatsapp_chat = {
        group: "resources",
        slug: "whatsapp_chat",
        name: this.$t("Whatsapp Chat"),
        description: this.$t("Add Whatsapp Chat."),
        icon: "ActionsAndInteractionsComponentIcon",
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.WHATSAPP_CHAT && !item.hidden
        ).length,

        sub_components: [
          {
            component_type: ALL_COMPONENTS.WHATSAPP_CHAT,
            id: ALL_COMPONENTS.WHATSAPP_CHAT,

            name: this.$t("Whatsapp Chat"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your component"),
                required: true,
                component_prop_name: "label"
              },
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.WHATSAPP_CHAT)
          }
        ]
      }

      //Notes
      const notes_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.NOTES)

      const notes = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.NOTES && !item.hidden)
          .length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "TextComponentIcon",

        slug: ALL_COMPONENTS.NOTES,
        name: this.$t("Notes"),
        description: this.$t("Add notes."),
        sub_components: [
          {
            component_type: ALL_COMPONENTS.NOTES,
            id: ALL_COMPONENTS.NOTES,

            name: this.$t("Notes"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: notes_instances
          }
        ]
      }

      //Data Source
      const data_source_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.DATA_SOURCE)

      const data_source = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.DATA_SOURCE && !item.hidden)
          .length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "TextComponentIcon",

        slug: ALL_COMPONENTS.DATA_SOURCE,
        name: this.$t("Data Source"),
        description: this.$t("Add data source."),
        sub_components: [
          {
            component_type: ALL_COMPONENTS.DATA_SOURCE,
            id: ALL_COMPONENTS.DATA_SOURCE,

            name: this.$t("Data Source"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: data_source_instances
          }
        ]
      }

      //IMAGES
      const image_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.IMAGE)

      const images = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.IMAGE && !item.hidden)
          .length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "ImageComponentIcon",
        slug: ALL_COMPONENTS.IMAGE,
        name: this.$t("Image"),
        description: this.$t("Add an image."),
        instances: image_instances,
        sub_components: [
          {
            component_type: ALL_COMPONENTS.IMAGE,
            id: ALL_COMPONENTS.IMAGE,

            name: this.$t("Image"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: image_instances
          }
        ]
      }

      //VIDEOS
      const video_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.VIDEO)

      const videos = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.VIDEO && !item.hidden)
          .length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "ImageComponentIcon",
        slug: ALL_COMPONENTS.VIDEO,
        name: this.$t("Video"),
        description: this.$t("Add a video."),
        instances: video_instances,
        sub_components: [
          {
            component_type: ALL_COMPONENTS.VIDEO,
            id: ALL_COMPONENTS.VIDEO,

            name: this.$t("Video"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: video_instances
          }
        ]
      }

      //Assets
      const resource_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.ASSETS)

      const assets = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.ASSETS && !item.hidden)
          .length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "AssetsComponentIcon",
        slug: ALL_COMPONENTS.ASSETS,
        name: this.$t("Docs & Files"),
        description: this.$t("Add documents & files that can be shared."),

        sub_components: [
          {
            component_type: ALL_COMPONENTS.ASSETS,
            id: ALL_COMPONENTS.ASSETS,

            name: this.$t("Docs & Files"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: resource_instances
          }
        ]
      }

      //MEET THE TEAM
      const team_card_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.TEAM_CARD)

      const team_cards = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.TEAM_CARD && !item.hidden)
          .length,
        group: "resources",
        can_be_tied_to_record: true,
        icon: "MeetTheTeamComponentIcon",
        slug: ALL_COMPONENTS.TEAM_CARD,
        name: this.$t("Meet The Team"),
        description: this.$t("A card for team member."),
        sub_components: [
          {
            component_type: ALL_COMPONENTS.TEAM_CARD,
            id: ALL_COMPONENTS.TEAM_CARD,

            name: this.$t("Meet The Team"),
            fields: [
              {
                type: "text_input",
                label: this.$t("Name your instance"),
                required: true,
                component_prop_name: "label"
              }
            ],
            instances: team_card_instances
          }
        ],
        instances: team_card_instances
      }

      //Record titles
      const record_titles = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.RECORD_TITLE && !item.hidden)
          .length,
        group: "customer360",
        slug: "record_title",
        name: this.$t("Title"),
        description: this.$t("Show Title"),
        icon: "MeetTheTeamComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.RECORD_TITLE,
            id: ALL_COMPONENTS.RECORD_TITLE,
            name: this.$t("Title"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.RECORD_TITLE)
          }
        ]
      }

      //Insights
      const insights = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.INSIGHTS && !item.hidden)
          .length,
        group: "customer360",
        slug: "insights",
        name: this.$t("Insights"),
        description: this.$t("Insights"),
        icon: "MeetTheTeamComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.INSIGHTS,
            id: ALL_COMPONENTS.INSIGHTS,
            name: this.$t("Insights"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.INSIGHTS)
          }
        ]
      }

      //Owners
      const owners = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.RECORD_TITLE && !item.hidden)
          .length,
        group: "customer360",
        slug: "owners",
        name: this.$t("Owners"),
        description: this.$t("Show Owners"),
        icon: "MeetTheTeamComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.OWNERS,
            id: ALL_COMPONENTS.OWNERS,
            name: this.$t("Owners List"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.OWNERS)
          }
        ]
      }

      //Key People
      const key_people = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.KEY_PEOPLE && !item.hidden)
          .length,
        group: "customer360",
        slug: "key_people",
        name: this.$t("Key People"),
        description: this.$t("Show Key People"),
        icon: "MeetTheTeamComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.KEY_PEOPLE,
            id: ALL_COMPONENTS.KEY_PEOPLE,
            name: this.$t("Key People List"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.KEY_PEOPLE)
          }
        ]
      }

      //Last Touch
      const last_touch = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.LAST_TOUCH && !item.hidden)
          .length,
        group: "customer360",
        slug: "last_touch",
        name: this.$t("Last Touch"),
        description: this.$t("Show Last Touch"),
        icon: "MeetTheTeamComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.LAST_TOUCH,
            id: ALL_COMPONENTS.LAST_TOUCH,
            name: this.$t("Last Touch List"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.LAST_TOUCH)
          }
        ]
      }

      //Last quality Touch
      const last_quality_touch = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.LAST_TOUCH && !item.hidden)
          .length,
        group: "customer360",
        slug: "last_quality_touch",
        name: this.$t("Last Quality Touch"),
        description: this.$t("Show Last Quality Touch"),
        icon: "MeetTheTeamComponentIcon",
        sub_components: [
          {
            component_type: ALL_COMPONENTS.LAST_QUALITY_TOUCH,
            id: ALL_COMPONENTS.LAST_QUALITY_TOUCH,
            name: this.$t("Last Quality List"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.LAST_QUALITY_TOUCH)
          }
        ]
      }

      //AI Insights
      const ai_insights_instances = this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.AI_INSIGHTS)

      const ai_insights = {
        items_added: this.currentTemplate.layout?.filter((item) => item.props.component_type == ALL_COMPONENTS.AI_INSIGHTS && !item.hidden)
          .length,
        group: "ai",
        can_be_tied_to_record: true,
        icon: "AIComponentsIcon",
        slug: ALL_COMPONENTS.AI_INSIGHTS,
        name: this.$t("AI Insights"),
        description: this.$t("Add AI Insights."),
        instances: ai_insights_instances,
        sub_components: [
          {
            component_type: ALL_COMPONENTS.AI_INSIGHTS,
            id: ALL_COMPONENTS.AI_INSIGHTS,

            name: this.$t("AI INSIGHTS"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: ai_insights_instances
          }
        ]
      }

      //AI Quick Actions
      const ai_quick_actions_instances = this.currentTemplate.layout?.filter(
        (item) => item.props.component_type == ALL_COMPONENTS.AI_QUICK_ACTIONS
      )

      const ai_quick_actions = {
        items_added: this.currentTemplate.layout?.filter(
          (item) => item.props.component_type == ALL_COMPONENTS.AI_QUICK_ACTIONS && !item.hidden
        ).length,
        group: "ai",
        can_be_tied_to_record: true,
        icon: "ImageComponentIcon",
        slug: ALL_COMPONENTS.AI_QUICK_ACTIONS,
        name: this.$t("AI Quick Actions"),
        description: this.$t("Add AI Quick Actions."),
        instances: ai_quick_actions_instances,
        sub_components: [
          {
            component_type: ALL_COMPONENTS.AI_QUICK_ACTIONS,
            id: ALL_COMPONENTS.AI_QUICK_ACTIONS,

            name: this.$t("AI Quick Actions"),
            fields: [
              {
                type: "select",
                label: this.$t("Connect to"),
                options: this.connect_to_options,
                value_attr: "value",
                label_attr: "name",
                required: true,
                component_prop_name: "connectTo",
                disabled: in_workspace,
                default_value: "another_record"
              },
              {
                type: "company_select",
                label: this.$t("Select Record"),
                required: true,
                component_prop_name: "linkedRecord",
                linked_field: "connectTo",
                disabled: in_workspace || dynamic_source_type == "specific_record",
                linked_field_value_to_show: "another_record",
                default_value: in_workspace
                  ? current_workspace.record
                  : dynamic_source_type == "specific_record"
                    ? dynamic_source_selection_id
                    : null
              }
            ],
            instances: ai_quick_actions_instances
          }
        ]
      }

      const all_components = forecast_data_sources_options.length
        ? [
            activity_tables,
            standard_metrics,
            new_resources,
            team_chat,
            whatsapp_chat,
            send_email,
            milestone_components,
            lead_tables,
            forecasting_tables,
            expansion_tables,
            record_tables,
            rollups,
            scores,
            graphs,
            forecast_metrics,
            journeys,
            growth_matrices,
            suggested_lists,
            find_leads,
            calendar_list,
            texts,
            notes,
            data_source,
            images,
            videos,
            assets,
            team_cards,
            checklist_list,
            company_map_list,
            overview_list,
            record_titles,
            insights,
            owners,
            key_people,
            last_touch,
            last_quality_touch,
            ai_insights,
            ai_quick_actions_instances,
            ai_quick_actions
          ]
        : [
            activity_tables,
            standard_metrics,
            new_resources,
            team_chat,
            whatsapp_chat,
            send_email,
            milestone_components,
            lead_tables,
            forecasting_tables,
            expansion_tables,
            record_tables,
            rollups,
            scores,
            graphs,
            journeys,
            growth_matrices,
            suggested_lists,
            find_leads,
            calendar_list,
            texts,
            notes,
            data_source,
            images,
            videos,
            assets,
            team_cards,
            checklist_list,
            company_map_list,
            overview_list,
            record_titles,
            insights,
            owners,
            key_people,
            last_touch,
            last_quality_touch,
            ai_insights,
            ai_quick_actions_instances,
            ai_quick_actions
          ]

      let workspace_components = null
      if (this.$route.name == "WorkspaceItem") {
        let workspace_page_components_list = null
        workspace_page_components_list = this.workspace_pages_components_list.find((p) => p.id == this.$route.params.page)
        if (workspace_page_components_list) {
          workspace_components = all_components.filter((c) => workspace_page_components_list.components.includes(c.slug))
        } else {
          workspace_components = all_components
        }
      }

      return workspace_components ? workspace_components : all_components
    },

    workspace_pages_components_list() {
      return [
        {
          id: "welcome",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "success_activities",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "projects",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "shared_goals",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "to_dos",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "customer_overview",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "insights",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "checklists",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "documents_and_files",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "health_and_usage",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        },
        {
          id: "meet_your_team",
          components: [
            ALL_COMPONENTS.ACTIONS_TABLE,
            ALL_COMPONENTS.LEADS_TABLE,
            ALL_COMPONENTS.FORECASTING_TABLE,
            ALL_COMPONENTS.OBJECT_TABLE,
            ALL_COMPONENTS.ROLLUP_METRIC,
            ALL_COMPONENTS.SCORE,
            ALL_COMPONENTS.GRAPH,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.FORECASTING_METRIC,
            ALL_COMPONENTS.CALENDAR,
            ALL_COMPONENTS.TEXT,
            ALL_COMPONENTS.NOTES,
            ALL_COMPONENTS.IMAGE,
            ALL_COMPONENTS.VIDEO,
            ALL_COMPONENTS.TEAM_CARD,
            ALL_COMPONENTS.ASSETS,
            ALL_COMPONENTS.CHECKLIST,
            ALL_COMPONENTS.COMPANY_MAP,
            ALL_COMPONENTS.OVERVIEW,
            ALL_COMPONENTS.MILESTONE
          ]
        }
      ]
    },
    components_lists_groups() {
      let workspace_page_components_list = null

      if (this.$route.name == "WorkspaceItem") {
        workspace_page_components_list = this.workspace_pages_components_list.find((p) => p.id == this.$route.params.page)
      }

      const all_components_grouped = [
        {
          icon: "PortfolioOverviewGroupIcon",
          background_color_1: "#59BEE5",
          background_color_2: "#118EBE",
          group_name: this.$t("Portfolio Overview"),
          id: "portfolio_overview",
          components: this.components_list.filter((c) => c.group == "portfolio_overview").map((c) => c.slug),
          description: this.$t("Show Portfolio data in table format."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              this.components_list
                .filter((c) => c.group == "portfolio_overview")
                .map((c) => c.slug)
                .includes(item.props.component_type) && !item.hidden
          ).length
        },
        {
          icon: "Customer360GroupIcon",
          background_color_1: "#5CE0A9",
          background_color_2: "#2AC986",
          group_name: this.$t("Customer 360"),
          id: "customer360",
          components: this.components_list.filter((c) => c.group == "customer360").map((c) => c.slug),
          description: this.$t("Show key data, KPI and insights about your customers."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              this.components_list
                .filter((c) => c.group == "customer360")
                .map((c) => c.slug)
                .includes(item.props.component_type) && !item.hidden
          ).length
        },
        {
          icon: "InsightsGroupIcon",
          group_name: this.$t("Insights"),
          background_color_1: "#B171F9",
          background_color_2: "#841FF4",
          id: "insights",
          components: this.components_list.filter((c) => c.group == "insights").map((c) => c.slug),
          description: this.$t("Leverage key insights in a variety of ways including metrics, scores and graphs."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              [this.components_list.filter((c) => c.group == "insights").map((c) => c.slug)].includes(item.props.component_type) &&
              !item.hidden
          ).length
        },
        {
          icon: "RevenueGroupIcon",
          background_color_1: "#F9A271",
          background_color_2: "#F46C1F",
          group_name: this.$t("Revenue"),
          id: "revenue",
          components: this.components_list.filter((c) => c.group == "revenue").map((c) => c.slug),
          description: this.$t("Display key forecasting and revenue data."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              [this.components_list.filter((c) => c.group == "revenue").map((c) => c.slug)].includes(item.props.component_type) &&
              !item.hidden
          ).length
        },
        {
          icon: "ExpansionGroupIcon",
          background_color_1: "#F971EB",
          background_color_2: "#CB37BC",
          group_name: this.$t("Expansion & Growth"),
          id: "expansion_and_growth",
          components: this.components_list.filter((c) => c.group == "expansion_and_growth").map((c) => c.slug),
          description: this.$t("Unlock expansion and growth using a variety of elements."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              [this.components_list.filter((c) => c.group == "expansion_and_growth").map((c) => c.slug)].includes(
                item.props.component_type
              ) && !item.hidden
          ).length
        },
        {
          icon: "LifecycleGroupIcon",
          background_color_1: "#F97171",
          background_color_2: "#BF2B2B",
          group_name: this.$t("Lifecycle & Workflows"),
          id: "lifecycle_and_workflows",
          components: this.components_list.filter((c) => c.group == "lifecycle_and_workflows").map((c) => c.slug),
          description: this.$t("Showcase key lifecycle, journey and activity data, status and progress."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              [this.components_list.filter((c) => c.group == "lifecycle_and_workflows").map((c) => c.slug)].includes(
                item.props.component_type
              ) && !item.hidden
          ).length
        },
        {
          icon: "ResourcesGroupIcon",
          background_color_1: "#FFC700",
          background_color_2: "#DC9E00",
          group_name: this.$t("Resources"),
          id: "resources",
          components: this.components_list
            .filter((c) => c.group == "resources" && !(c.slug == "data_source" && this.$route.name != "Dashboard"))
            .map((c) => c.slug),
          description: this.$t("Use different resources like text, image and files."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              [this.components_list.filter((c) => c.group == "resources").map((c) => c.slug)].includes(item.props.component_type) &&
              !item.hidden
          ).length
        },
        {
          icon: "AIComponentsIcon",
          background_color_1: "#2DA7D7",
          background_color_2: "#841FF4",
          group_name: this.$t("AI"),
          id: "ai",
          components: this.components_list
            .filter((c) => c.group == "ai" && !(c.slug == "data_source" && this.$route.name != "Dashboard"))
            .map((c) => c.slug),
          description: this.$t("Use different ai like text, image and files."),
          items_added: this.currentTemplate.layout?.filter(
            (item) =>
              [this.components_list.filter((c) => c.group == "ai").map((c) => c.slug)].includes(item.props.component_type) && !item.hidden
          ).length
        }
      ]

      const all_components_grouped_unaivalable_pages_removed = []
      if (workspace_page_components_list) {
        all_components_grouped.forEach((group) => {
          if (group.components.filter((c) => workspace_page_components_list.components.includes(c)).length) {
            all_components_grouped_unaivalable_pages_removed.push({
              ...group,
              components: this.$utils.clone(group.components.filter((c) => workspace_page_components_list.components.includes(c)))
            })
          }
        })
      }

      return workspace_page_components_list ? all_components_grouped_unaivalable_pages_removed : all_components_grouped
    },

    filtered_components_lists_groups() {
      const filtered_list = this.components_lists_groups.filter((c) => {
        return c.group_name.toLowerCase().includes(this.search_term.toLowerCase())
      })

      return filtered_list
    },

    object_type_to_filter_with() {
      const default_pages = ["overview", "map", "actions", "checklists"]
      if (default_pages.includes(this.$route.params.page)) {
        if (this.$route.name == "CompanyProfile" || this.$route.name == "ObjectProfile") {
          return this.$store.state.ui.currentCompany.type
        }
      }
      if (this.$store.state.object_types.find((o) => o.type == this.$route.params?.page)) {
        return this.$store.state.object_types.find((o) => o.type == this.$route.params?.page)?.type
      }

      const dynamic_data_source = this.currentTemplate.layout?.find((item) => item.id == "dynamic_source_selection")
      if (dynamic_data_source) {
        const dynamic_data_source_array = dynamic_data_source.data_source_string.split(">")
        return dynamic_data_source_array[0]
      }
      return null
    },

    is_inside_object_page() {
      return this.$store.state.object_types.find((o) => o.type == this.$route.params?.page)
    }
  },

  created() {
    this.init()
    this.register_listners()
  },
  activated() {
    this.register_listners()
  },

  unmounted() {
    this.unregister_listners()
  },
  deactivated() {
    this.unregister_listners()
  },

  methods: {
    handleAddNewComponentClick() {
      const component_calc = this.step.split("__")[1]
      this.items_changed = true
      if (component_calc == "score") {
        this.$router.push(`/admin/scores/new-score?redirect_url=${this.$route.fullPath}&page_ref=${this.pageReference}`)
        this.$emitter.emit(ALL_EMITTERS.CLOSE_ADD_NEW_COMPONENT)
      } else if (component_calc == "rollup") {
        this.$router.push(
          `/admin/metrics?tab=calculated-metrics&o=company&redirect_url=${this.$route.fullPath}&page_ref=${this.pageReference}`
        )
        this.$emitter.emit(ALL_EMITTERS.CLOSE_ADD_NEW_COMPONENT)
      } else if (component_calc == "graph") {
        this.selected_component = "graph"
        this.form_active = true
      }
    },

    async handleCreateComponent() {
      this.items_changed = true
      const values = this.new_component_data

      let data = { ...values }
      if (this.selected_component == "graph") {
        data["page_reference"] = this.pageReference

        if (data.filter != null && data.filter) {
          data = { ...data, filter: data.filter }
        } else {
          delete data.filter
        }

        data["series"] = values.selected_series

        if (this.instance_to_edit) {
          this.form_active = false
          await this.$store.dispatch("data/updateGraph", { id: this.instance_to_edit.id, data }).then(() => {
            this.$store.dispatch("data/getAllGraphsFlat")
            const index = this.currentTemplate.layout.findIndex(
              (l) => l.props.component_type == "graph" && l.id == this.instance_to_edit.id
            )
            const current_template_clone = this.$utils.clone(this.currentTemplate)

            current_template_clone.layout.splice(index, 1, {
              ...current_template_clone.layout[index],
              ...data
            })
            this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED, {
              layout: current_template_clone,
              page_name: this.$route.params.page
            })
            this.$emitter.emit(ALL_EMITTERS.LAYOUT_UPDATED_IN_ADD_COMPONENTES_MODAL, {
              layout: current_template_clone,
              page_name: this.$route.params.page
            })
          })
        } else {
          this.$store
            .dispatch("data/createGraph", data)
            .then((res) => {
              this.form_active = false

              setTimeout(() => {
                this.$emitter.emit(ALL_EMITTERS.ADD_GRAPH_TO_COMPONENTS, {
                  ...res,
                  text_color: data.graph_text_color,
                  background_color: data.graph_background_color
                })
              }, 200)
            })
            .catch(() => {})
        }
      } else {
        let component_props = {}

        if (this.selected_component == "image") {
          dataService.addAttachment({ attachments: this.new_component_data.attachments }).then((result) => {
            if (this.new_component_data["connectTo"] && this.new_component_data["connectTo"] !== "all_pages") {
              component_props["url"] = {}
              component_props.url[this.new_component_data["page_identifier"]] = result.data[0].file
              component_props["label"] = {}
              component_props.label[this.new_component_data["page_identifier"]] = result.data[0].name
              component_props["backgroundColor"] = {}
              component_props.backgroundColor[this.new_component_data["page_identifier"]] = this.new_component_data["backgroundColor"]

              this.$store.dispatch("getPortfolio")
            } else {
              component_props = {
                url: result.data[0].file,
                label: result.data[0].name,
                backgroundColor: this.new_component_data["backgroundColor"]
              }
            }

            const data_obj = {
              id: result.data[0].id,
              props: {
                component_type: this.selected_component,
                component_props
              }
            }

            this.addItemDynamically(data_obj)
            this.form_active = false
          })
        } else if (this.selected_component == "video") {
          if (this.new_component_data?.attachments?.length) {
            dataService.addAttachment({ attachments: this.new_component_data.attachments }).then((result) => {
              if (this.new_component_data["connectTo"] && this.new_component_data["connectTo"] !== "all_pages") {
                component_props["url"] = {}
                component_props.url[this.new_component_data["page_identifier"]] = result.data[0].file
                component_props["label"] = {}
                component_props.label[this.new_component_data["page_identifier"]] = result.data[0].name
                component_props["backgroundColor"] = {}
                component_props.backgroundColor[this.new_component_data["page_identifier"]] = this.new_component_data["backgroundColor"]
                this.$store.dispatch("getPortfolio")
              } else {
                component_props = {
                  url: result.data[0].file,
                  label: result.data[0].name,
                  backgroundColor: this.new_component_data["backgroundColor"]
                }
              }

              const data_obj = {
                id: uuidv4(),
                props: {
                  component_type: this.selected_component,
                  component_props
                }
              }

              this.addItemDynamically(data_obj)
              this.form_active = false
            })
          } else {
            if (this.new_component_data["connectTo"] && this.new_component_data["connectTo"] !== "all_pages") {
              component_props["url"] = {}
              component_props.url[this.new_component_data["page_identifier"]] = this.new_component_data["url"]
              component_props["label"] = {}
              component_props.label[this.new_component_data["page_identifier"]] = this.new_component_data["url"]
              component_props["backgroundColor"] = {}
              component_props.backgroundColor[this.new_component_data["page_identifier"]] = this.new_component_data["backgroundColor"]
              this.$store.dispatch("getPortfolio")
            } else {
              component_props = {
                url: this.new_component_data["url"],
                label: this.new_component_data["url"],
                backgroundColor: this.new_component_data["backgroundColor"]
              }
            }

            const data_obj = {
              id: uuidv4(),
              props: {
                component_type: this.selected_component,
                component_props
              }
            }

            this.addItemDynamically(data_obj)
            this.form_active = false
          }
        } else if (this.selected_component == "assets") {
          if (this.new_component_data["linked_to"] && this.new_component_data["linked_to"] != "this_page") {
            component_props["label"] = this.new_component_data.label
            component_props["recordId"] = this.new_component_data.recordId
            component_props["connectTo"] = this.new_component_data.connectTo
            component_props["linked_to"] = this.new_component_data.linked_to
          } else {
            component_props["label"] = this.new_component_data.label
            component_props["attachments"] = []
            component_props["recordId"] = this.new_component_data.recordId
            component_props["connectTo"] = this.new_component_data.connectTo
            component_props["linked_to"] = this.new_component_data.linked_to
          }

          const data_obj = {
            props: {
              component_type: this.selected_component,
              component_props
            }
          }
          this.addItemDynamically(data_obj)
          this.$store.dispatch("getPortfolio")
          this.form_active = false
        } else if (this.selected_component == "notes") {
          if (this.new_component_data["connectTo"] && this.new_component_data["connectTo"] == "record_page") {
            component_props["label"] = this.new_component_data.label
            component_props["categories"] = this.new_component_data.categories
            component_props["recordId"] = this.new_component_data.recordId
            component_props["connectTo"] = this.new_component_data.connectTo
            component_props["linked_to"] = this.new_component_data.linked_to
          } else {
            component_props["label"] = this.new_component_data.label
            component_props["categories"] = this.new_component_data.categories
            component_props["notes"] = []
            component_props["recordId"] = this.new_component_data.recordId
            component_props["connectTo"] = this.new_component_data.connectTo
            component_props["linked_to"] = this.new_component_data.linked_to
          }

          this.$store.dispatch("getPortfolio")
          const data_obj = {
            props: {
              component_type: this.selected_component,
              component_props
            }
          }

          this.addItemDynamically(data_obj)
          this.form_active = false
        } else if (this.selected_component == "data_source") {
          if (this.new_component_data["connectTo"] && this.new_component_data["connectTo"] == "record_page") {
            component_props["label"] = this.new_component_data.label
            component_props["recordId"] = this.new_component_data.recordId
            component_props["connectTo"] = this.new_component_data.connectTo
            component_props["linked_to"] = this.new_component_data.linked_to
          } else {
            component_props["label"] = this.new_component_data.label
            component_props["recordId"] = this.new_component_data.recordId
            component_props["connectTo"] = this.new_component_data.connectTo
            component_props["linked_to"] = this.new_component_data.linked_to
          }

          this.$store.dispatch("getPortfolio")
          const data_obj = {
            props: {
              component_type: this.selected_component,
              component_props
            }
          }

          this.addItemDynamically(data_obj)
          this.form_active = false
        } else {
          if (this.new_component_data["connectTo"] && this.new_component_data["connectTo"] !== "all_pages") {
            const page_identifier = this.new_component_data["page_identifier"]

            //prepare layout component to be send to server by removing auxiliary fields
            delete this.new_component_data.connectTo
            delete this.new_component_data.page_identifier
            delete this.new_component_data.required_filled

            Object.keys(this.new_component_data).forEach((key) => {
              component_props[key] = {}
              component_props[key][page_identifier] = this.new_component_data[key]
            })
          } else {
            //prepare layout component to be send to server by removing auxiliary fields
            delete this.new_component_data.connectTo
            delete this.new_component_data.page_identifier
            delete this.new_component_data.required_filled

            component_props = { ...this.new_component_data }
          }

          const data_obj = {
            props: {
              component_type: this.selected_component,
              component_props
            }
          }

          this.addItemDynamically(data_obj)
          this.form_active = false
        }
      }
    },

    updateWorkspaceLayout(template) {
      const index = this.$store.state.ui.currentWorkspace.layout.findIndex((l) => l.id == this.$route.params.page)
      const layout_copy = this.$store.state.ui.currentWorkspace.layout

      if (template.id == this.$route.params.page && this.$route.params?.wid == this.$store.state.ui.currentWorkspace.short_id) {
        layout_copy.splice(index, 1, { ...layout_copy[index], layout: template.layout })
        this.$store.dispatch("data/updateWorkspace", {
          short_id: this.$route.params.wid,
          layout: layout_copy
        })
      }
    },
    submitForm(item) {
      this.items_changed = true
      const current_template_clone = this.$utils.clone(this.currentTemplate)

      if (item.id) {
        const index = this.currentTemplate.layout.findIndex((l) => l.id == item.id)
        delete item.id
        if (current_template_clone.layout[index].props.component_type == "video") {
          if (item.attachments.length) {
            dataService.addAttachment({ attachments: item.attachments }).then((result) => {
              current_template_clone.layout[index].props.component_props = {
                ...current_template_clone.layout[index].props.component_props,
                ...item,
                url: result.data[0].file,
                label: result.data[0].name
              }
              this.$emitter.emit(ALL_EMITTERS.COMPONENT_FORM_SUBMITTED, item)
              if (this.pageReference == "workspace") {
                this.updateWorkspaceLayout(current_template_clone)
              } else {
                this.setPageLayout(current_template_clone)
              }

              this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
                current_template: current_template_clone
              })
            })
          } else {
            current_template_clone.layout[index].props.component_props = {
              ...current_template_clone.layout[index].props.component_props,
              ...item,
              label: item.url
            }

            this.$emitter.emit(ALL_EMITTERS.COMPONENT_FORM_SUBMITTED, item)
            if (this.pageReference == "workspace") {
              this.updateWorkspaceLayout(current_template_clone)
            } else {
              this.setPageLayout(current_template_clone)
            }

            this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
              current_template: current_template_clone
            })
          }
        } else {
          current_template_clone.layout[index].props.component_props = {
            ...current_template_clone.layout[index].props.component_props,
            ...item
          }

          this.$emitter.emit(ALL_EMITTERS.COMPONENT_FORM_SUBMITTED, item)
          if (this.pageReference == "workspace") {
            this.updateWorkspaceLayout(current_template_clone)
          } else {
            this.setPageLayout(current_template_clone)
          }

          this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
            current_template: current_template_clone
          })
        }
      } else {
        this.$emitter.emit(ALL_EMITTERS.COMPONENT_FORM_SUBMITTED, item)

        this.instance_to_edit = null
        this.handleCreateComponent()
      }

      this.form_active = false
    },
    handleOpenEditForm(instance) {
      this.form_active = true
      this.instance_to_edit = instance.instance
      this.selected_component = instance.component_type
    },

    handleOpenAddNewForm(obj) {
      this.selected_component = obj.component_type
      this.$nextTick(() => {
        this.form_active = true
      })
    },

    handleNewComponentDataChange(values) {
      this.new_component_data = values
      this.creation_form_filled = values.required_filled
    },

    register_listners() {
      this.$emitter.on(ALL_EMITTERS.EDIT_INSTANCE, (instance) => {
        const selected_component = instance.props.component_type
        this.step = `component__${selected_component}`
        setTimeout(() => {
          this.$emitter.emit(ALL_EMITTERS.OPEN_INSTANCE_EDIT_FORM, instance)
        }, 100)
      })
      this.$emitter.on(ALL_EMITTERS.REPLACE_INSTANCE, (instance) => {
        const selected_component = instance.props.component_type
        this.step = `component__${selected_component}`
        this.is_replace_component = true
        setTimeout(() => {
          this.$emitter.emit(ALL_EMITTERS.OPEN_INSTANCE_REPLACE_FORM, instance)
        }, 100)
      })
    },
    unregister_listners() {
      this.$emitter.off(ALL_EMITTERS.EDIT_INSTANCE)
    },

    init() {
      dataService.getJourneys({ page_size: 10 }).then((result) => {
        this.journeys = result.data.results
      })

      dataService.getForecasts({ page_size: 100 }).then((result) => {
        if (result.data.results.length > 0) {
          this.user_forecasts = result.data.results
          this.forecasted_objects = this.$utils.uniqBy(this.user_forecasts, "type").map((x) => {
            return { ...this.$utils.getObjectTypeById(x.object_type) }
          })
          if (this.object_type_to_filter_with) {
            this.forecasted_objects = this.forecasted_objects.filter((f) => f.type == this.object_type_to_filter_with)
          }
        } else {
          //NO FORECASTING
        }
      })

      dataService.getExpansionLists().then((result) => {
        this.expansion_lists = [{ id: "all_lists", name: this.$t("All Lists") }].concat(result.data.results)
        if (this.object_type_to_filter_with) {
          this.expansion_lists = [{ id: "all_lists", name: this.$t("All Lists") }].concat(
            this.expansion_lists.filter((e) => e.type == this.object_type_to_filter_with)
          )
        }
      })
    },

    addItemDynamically(data) {
      const x = (this.currentTemplate.layout.filter((l) => !l.hidden).length * 2) % 72
      let last_y = 0
      this.currentTemplate.layout
        .filter((l) => !l.hidden)
        .forEach((item) => {
          if (item.y + item.h > last_y) {
            last_y = item.y + item.h
          }
        })
      const y = last_y

      let w = 24
      let h = 12
      let minW = 6
      let minH = 6
      let maxH = 72
      let preserveAspectRatio = false
      let id = uuidv4()

      if (data?.props?.component_type.toLowerCase().search("_table") != -1) {
        w = 72
        h = 36
        minH = 24

        if (data?.props?.component_type == "action_table") {
          minW = 48
          h = 24
        } else if (data?.props?.component_type == "lead_table") {
          h = 18
        }
        // props = { ...data.props, objectType: data.props?.component_props.objectType, data?.props?.component_type: data?.props?.component_type, component_reference: `${this.pageReference}>${this.page_name}>${this.currentTemplate.layout.length}` }
      } else if (data?.props?.component_type.toLowerCase() == "calendar") {
        w = 72
        h = data.props.component_props.viewOption == "week_view" ? 12 : 18
        minW = 48
        minH = data.props.component_props.viewOption == "week_view" ? 12 : 18
        maxH = data.props.component_props.viewOption == "week_view" ? 12 : 18
      } else if (data?.props?.component_type.toLowerCase() == ALL_COMPONENTS.AI_QUICK_ACTIONS) {
        h = 12
      } else if (data?.props?.component_type.toLowerCase() == "standard_metrics") {
        w = 72
        h = 5
      } else if (data?.props?.component_type.toLowerCase() == "new_resources") {
        w = 72
        h = 40
      } else if (data?.props?.component_type.toLowerCase() == "team_chat") {
        w = 24
        h = 30
      } else if (data?.props?.component_type.toLowerCase() == "whatsapp_chat") {
        w = 24
        h = 30
      } else if (data?.props?.component_type.toLowerCase() == "send_email") {
        w = 72
        h = 24
      } else if (data?.props?.component_type.toLowerCase() == "forecasting_metric") {
        if (data.metricName == "arr" || data.metricName == "mrr") {
          w = 12
          h = 6
          minW = 6
          minH = 6
        }
        if (data?.props?.component_props?.metricName == "forecast_status") {
          w = 48
          h = 21
          minW = 12
          minH = 6
        } else if (data?.props?.component_props?.metricName == "forecast_summary") {
          w = 32
          h = 7
          minW = 12
          minH = 7
        } else {
          w = 12
          h = 12
          minW = 12
          minH = 6
        }
      } else if (data?.props?.component_type.toLowerCase() == "journey") {
        w = 72
        h = 36
        minW = 24
        minH = 24
      } else if (data?.props?.component_type.toLowerCase() == "suggested_list") {
        w = 72
        h = 18
        minW = 24
        minH = 12
      } else if (data?.props?.component_type.toLowerCase() == "find_leads") {
        w = 72
        h = 18
        minW = minH = 12
      } else if (data?.props?.component_type.toLowerCase() == "growth_matrix") {
        w = 72
        h = 36
        minW = 48
        minH = 36
      } else if (data?.props?.component_type.toLowerCase() == "graph") {
        w = 24
        h = 24
        minW = 18
        minH = data.graph_type == "table" ? 6 : 18
        id = this.$utils.clone(data.id)
      } else if (data?.props?.component_type.toLowerCase() == "rollup" || data?.props?.component_type.toLowerCase() == "score") {
        w = 24
        if (data.props.component_props?.showDescription) {
          h = 12
        } else {
          h = 6
        }
        maxH = 12
        minW = 12
      } else if (data?.props?.component_type.toLowerCase() == "text") {
        w = 18
        h = 12
      } else if (data?.props?.component_type.toLowerCase() == "image") {
        id = this.$utils.clone(data.id)
        w = 18
        h = 12
      } else if (data?.props?.component_type.toLowerCase() == "video") {
        id = this.$utils.clone(data.id)
        w = 18
        h = 12
      } else if (data?.props?.component_type.toLowerCase() == "company_map") {
        w = 72
        h = 24
      } else if (data?.props?.component_type.toLowerCase() == "overview") {
        w = 72
        h = 24
      } else if (data?.props?.component_type.toLowerCase() == "milestone") {
        dataService.createMilestone({ name: data?.props?.component_props?.label }).then((result) => {
          data.props.component_props["milestoneId"] = result.data.id
        })
        if (data.props.component_props.componentType == "full") {
          w = 72
          h = 24
        } else {
          w = 24
          h = 24
        }
      } else if (data?.props?.component_type.toLowerCase() == "data_source") {
        w = 24
        h = 6
        minW = 24
        minH = 6
      } else if (data?.props?.component_type.toLowerCase() == "insights") {
        w = 48
        h = 36
        minW = 24
        minH = 24
      } else {
        w = 24
        h = 24
      }

      if (data?.props?.component_type.toLowerCase() == "milestone") {
        //Waiting to create milestone before adding it to the layout
        setTimeout(() => {
          let item = {
            ...data,
            x: x,
            y: y,
            minW,
            minH,
            maxH,
            w: w,
            h: h,
            id: id,
            preserveAspectRatio
          }

          const current_template_clone = this.$utils.clone(this.currentTemplate)
          current_template_clone.layout.push(item)
          if (this.pageReference == "workspace") {
            this.updateWorkspaceLayout(current_template_clone)
          } else {
            this.setPageLayout(current_template_clone)
          }

          this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
            current_template: current_template_clone
          })

          this.$toast.open({
            message: `${this.$utils.capitalize(item.props.component_type.replaceAll("_", " "))} added`,
            position: "top",
            type: "success",
            duration: 3000
          })
        }, 2000)
      } else {
        let item = {
          ...data,
          x: x,
          y: y,
          minW,
          minH,
          maxH,
          w: w,
          h: h,
          id: id,
          preserveAspectRatio
        }

        const current_template_clone = this.$utils.clone(this.currentTemplate)
        current_template_clone.layout.push(item)

        if (this.pageReference == "workspace") {
          this.updateWorkspaceLayout(current_template_clone)
        } else {
          this.setPageLayout(current_template_clone)
        }

        this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
          current_template: current_template_clone
        })

        this.$toast.open({
          message: `${this.$utils.capitalize(item.props.component_type.replaceAll("_", " "))} added`,
          position: "top",
          type: "success",
          duration: 3000
        })

        // this.currentTemplate.layout.push(item)
        // this.updateLayout()
        google_event("component_added_click", {
          event_label: "Add new component",
          component_type: data.props.component_type,
          page: this.currentTemplate.page,
          name: this.currentTemplate.name,
          user_name: this.$store.state.auth.user.full_name,
          user_email: this.$store.state.auth.user.email,
          organization: this.$store.state.organization.name
        })
      }
    },

    createNewInstance(item) {
      this.items_changed = true
      this.addItemDynamically(item)
    },

    changeInstanceHidden(item) {
      this.items_changed = true
      const index = this.currentTemplate.layout.findIndex((l) => l.id == item.id)
      const current_template_clone = this.$utils.clone(this.currentTemplate)
      if (current_template_clone.layout[index]?.props.hidden) {
        current_template_clone.layout.splice(index, 1, {
          ...item,
          props: { ...item.props, hidden: false }
        })
      } else {
        current_template_clone.layout.splice(index, 1, {
          ...item,
          props: { ...item.props, hidden: true }
        })
      }

      if (this.pageReference == "workspace") {
        this.updateWorkspaceLayout(current_template_clone)
      } else {
        this.setPageLayout(current_template_clone)
      }

      this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
        current_template: current_template_clone
      })

      setTimeout(() => {
        this.removeLinkedMetrics(item)
      }, 1200)
    },

    removeLinkedMetrics(item) {
      const component_reference = item.props?.component_reference

      const layout_copy = this.$utils.clone(this.currentTemplate.layout)
      this.currentTemplate.layout.forEach((instance) => {
        if (instance.props.component_type == "forecasting_metric" && instance.props.component_props.dataSource == component_reference) {
          const index = layout_copy.findIndex((l) => l.id == instance.id)
          layout_copy.splice(index, 1)
        }
        if (instance.props.component_type == "rollup" && instance.props.component_props.dataSource == component_reference) {
          const index = layout_copy.findIndex((l) => l.id == instance.id)
          layout_copy.splice(index, 1, {
            ...instance,
            props: {
              ...instance.props,
              component_props: {
                ...instance.props.component_props,
                dataSource: "all_records"
              }
            }
          })
        }
      })

      const current_template_clone = this.$utils.clone(this.currentTemplate)
      current_template_clone.layout = layout_copy

      if (this.pageReference == "workspace") {
        this.updateWorkspaceLayout(current_template_clone)
      } else {
        this.setPageLayout(current_template_clone)
      }

      this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
        current_template: current_template_clone
      })
    },

    deleteInstance(item) {
      const component_reference = item.props?.component_reference

      const layout_copy = this.$utils.clone(this.currentTemplate.layout)
      this.currentTemplate.layout.forEach((instance) => {
        if (instance.props.component_type == "forecasting_metric" && instance.props.component_props.dataSource == component_reference) {
          const index = layout_copy.findIndex((l) => l.id == instance.id)
          layout_copy.splice(index, 1)
        }
        if (instance.props.component_type == "rollup" && instance.props.component_props.dataSource == component_reference) {
          const index = layout_copy.findIndex((l) => l.id == instance.id)
          layout_copy.splice(index, 1, {
            ...instance,
            props: {
              ...instance.props,
              component_props: {
                ...instance.props.component_props,
                dataSource: "all_records"
              }
            }
          })
        }
      })

      this.items_changed = true
      const index = layout_copy.findIndex((l) => l.id == item.id)
      layout_copy.splice(index, 1)

      const current_template_clone = this.$utils.clone(this.currentTemplate)
      current_template_clone.layout = layout_copy

      if (this.pageReference == "workspace") {
        this.updateWorkspaceLayout(current_template_clone)
      } else {
        this.setPageLayout(current_template_clone)
      }

      this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
        current_template: current_template_clone
      })
    },

    editInstance(new_item) {
      this.items_changed = true

      const index = this.currentTemplate.layout.findIndex((l) => l.id == new_item.id)

      const instance_with_dimensions = this.calcInstancewithNewDimensions(new_item)

      const current_template_clone = this.$utils.clone(this.currentTemplate)
      current_template_clone.layout.splice(index, 1, instance_with_dimensions)

      if (this.pageReference == "workspace") {
        this.updateWorkspaceLayout(current_template_clone)
      } else {
        this.setPageLayout(current_template_clone)
      }

      this.$emitter.emit(ALL_EMITTERS.CURRENT_TEMPLATE_UPDATED, {
        current_template: current_template_clone
      })
      if (this.is_replace_component) {
        this.$emit("cancel")
      }
    },

    calcInstancewithNewDimensions(item) {
      const item_obj = this.$utils.clone(item)
      if (item.props.component_type == "calendar") {
        if (item.props.component_props.viewOption == "week_view") {
          item_obj.h = 12
          item_obj.maxH = 12
          item_obj.minH = 12
        } else {
          item_obj.h = 18
          item_obj.maxH = 18
          item_obj.minH = 18
        }
      }
      return item_obj
    },

    handleCategorySelect(category) {
      this.step = `category__${category}`
      this.search_term = ""
    },

    handleComponentSelect(component) {
      this.step = `component__${component}`
      this.search_term = ""
    },

    handleBackClick() {
      if (this.step.split("__")[0] == "category") {
        this.step = "main"
        this.search_term = ""
      }

      if (this.step.split("__")[0] == "component") {
        this.step = `category__${this.current_component_category.id}`
      }
    }
  }
}
</script>
